import styled from 'styled-components'

import { Row } from '../MessageBubble/MessageBubble.styles'

/** Stays mounted while the bubble and the editor swap, so focus can be put back after editing. */
export const Body = styled.span`
  display: contents;
`

export const BubbleLine = styled.span`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 4px;
  max-width: 100%;
`

/** Holds the edit and delete buttons; shown while the message row is hovered or focused. */
export const ActionsSlot = styled.span`
  flex: none;
  opacity: 0;
  transition: opacity 120ms ease;

  ${Row}:hover &,
  ${Row}:focus-within & {
    opacity: 1;
  }

  @media (hover: none) {
    opacity: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
